<template>
	<div id="videos-uploader-widget">
		<div class="uploader-body">
			<div v-if="stream && !stream.liveParent && !advertisingMediaUpload" class="d-flex flex-wrap align-items-start">
				<input ref="uploadInput" type="file" :multiple="false" style="display: none;" accept="video/mp4" name="fields[assetsFieldHandle][]" id="assetsFieldHandle" @change="onChange">
				<b-dropdown dropright id="dropdown-upload" no-caret :disabled="vodSubExpiredDays < 0" variant="icon-7" size="sm" class="w-100" menu-class="dropdown-menu_sm" toggle-class="p-0 no-shadow">
					<template #button-content>
						<div class="d-flex justify-content-start align-items-center w-100">
							<svg class="flex-shrink-0 mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M6.17513 2.10043C6.25916 2.10042 6.33379 2.10052 6.40048 2.10084V5.5004C6.40048 6.38405 7.11683 7.1004 8.00048 7.1004H11.9974L12.0006 7.10041C12.332 7.10041 12.6006 6.83178 12.6006 6.50041C12.6006 6.02113 12.4102 5.56149 12.0713 5.22259L8.86218 2.01342L8.81703 1.96825C8.51488 1.66586 8.29423 1.44503 8.03071 1.28355C7.79807 1.14099 7.54445 1.03594 7.27915 0.97225C6.97862 0.900102 6.66645 0.900231 6.23898 0.900408L6.17511 0.900425L4.70033 0.900448L4.6752 0.900448C4.1365 0.900449 3.69594 0.90045 3.3379 0.929709C2.96729 0.959994 2.63258 1.02459 2.31999 1.18386C1.83078 1.43314 1.43303 1.83088 1.18377 2.3201C1.0245 2.63269 0.959911 2.96741 0.929632 3.33801C0.900378 3.69606 0.900384 4.13661 0.900391 4.67531L0.900391 4.67531L0.900391 4.70045V10.8003L0.900391 10.8255C0.900384 11.3642 0.900378 11.8047 0.929633 12.1628C0.959914 12.5334 1.0245 12.8681 1.18378 13.1807C1.43306 13.67 1.83082 14.0677 2.32006 14.317C2.63266 14.4763 2.96739 14.5408 3.338 14.5711C3.69606 14.6004 4.13663 14.6003 4.67533 14.6003H4.70049L5.00053 14.6003C5.3319 14.6003 5.60052 14.3317 5.60051 14.0003C5.6005 13.6689 5.33187 13.4003 5.0005 13.4003L4.70046 13.4003C4.13049 13.4003 3.7391 13.3999 3.43569 13.3751C3.13928 13.3509 2.98006 13.3065 2.86483 13.2478C2.60139 13.1136 2.38721 12.8994 2.25299 12.6359C2.19427 12.5207 2.14987 12.3615 2.12565 12.0651C2.10086 11.7617 2.10039 11.3703 2.10039 10.8003V4.70045C2.10039 4.1305 2.10086 3.73913 2.12565 3.43573C2.14986 3.13933 2.19427 2.98012 2.25298 2.86489C2.3872 2.60146 2.60137 2.38729 2.86479 2.25306C2.98002 2.19435 3.13924 2.14994 3.43563 2.12572C3.73903 2.10093 4.13041 2.10046 4.70035 2.10045L6.17513 2.10043ZM8.01365 2.86195L11.0521 5.9004H8.00048C7.77957 5.9004 7.60048 5.72131 7.60048 5.5004V2.45933C7.69335 2.54321 7.81781 2.66611 8.01365 2.86195ZM11.1005 9.50043C11.1005 9.16906 10.8319 8.90043 10.5005 8.90043C10.1691 8.90043 9.90048 9.16906 9.90048 9.50043V11.9004H7.50048C7.16911 11.9004 6.90048 12.1691 6.90048 12.5004C6.90048 12.8318 7.16911 13.1004 7.50048 13.1004H9.90048V15.5004C9.90048 15.8318 10.1691 16.1004 10.5005 16.1004C10.8319 16.1004 11.1005 15.8318 11.1005 15.5004V13.1004H13.5005C13.8319 13.1004 14.1005 12.8318 14.1005 12.5004C14.1005 12.1691 13.8319 11.9004 13.5005 11.9004H11.1005V9.50043Z" fill="currentColor"/>
							</svg>
							New Video
							<svg class="ml-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="16" height="16" fill="black" fill-opacity="0.01"/>
								<path fill-rule="evenodd" clip-rule="evenodd" d="M5.57613 3.07613C5.81044 2.84181 6.19034 2.84181 6.42465 3.07613L10.9247 7.57613C11.159 7.81044 11.159 8.19034 10.9247 8.42465L6.42465 12.9247C6.19034 13.159 5.81044 13.159 5.57613 12.9247C5.34181 12.6903 5.34181 12.3104 5.57613 12.0761L9.65186 8.00039L5.57613 3.92465C5.34181 3.69034 5.34181 3.31044 5.57613 3.07613Z" fill="currentColor" fill-opacity="0.5"/>
							</svg>
						</div>	
					</template>
					<b-dropdown-item v-if="!isDisabledControl && showUploadButton && (allowMultipleUploads || (videoFiles.length === 0 && uploadList.length === 0))" @click.stop.prevent="openFileUpload($event)">From Your Computer</b-dropdown-item>
					<b-dropdown-item v-if="!isTrialSub" v-b-modal.cloud-import-box-drop>Cloud import <b-badge variant="dark-5" class="badge_beta ml-2">beta</b-badge></b-dropdown-item>
				</b-dropdown>
				<div v-if="isDisabledControl" class="text-danger">Disable schedule to rearrange files</div>
			</div>
		</div>
		<alert-modal
			:message="uploadErrorMessage || 'You are exceeding your storage limit. Please upgrade to continue'"
			modal-id="alert-storage-exceeding"
			ok-text="Got it, thanks"
			button-alignment="text-right"
		/>
		<upload-alert-modal
			modal-id="alert-video-max-size"
			:message="maxFileSizeErrorTitle"
			:body="maxFileSizeErrorMessage|| 'Your file size cannot exceed. Upload smaller file or upgrade your plan to continue.'"
			ok-text="Cancel"
			button-alignment="text-right"
		/>
		<alert-modal
			:message="maxFileNumberErrorMessage || 'Your number of files cannot exceed. Upgrade your plan if you need more files.'"
			modal-id="alert-video-max-file"
			ok-text="Got it, thanks"
			button-alignment="text-right"
		/>
		<alert-modal
			message="Please upload MP4 files only."
			modal-id="forbidden-file-format-modal-light"
			ok-text="Ok"
			button-alignment="text-right"
		/>
	</div>
</template>
<script>
import axios from 'axios';
import Spinner from "@/components/ui/Spinner.vue"
import StreamService from '@/services/StreamService';
import UserService from "@/services/UserService";
import utils from '@/utils';
import Dropzone from '@/components/Dropzone.vue';
import AlertModal from '@/components/modals/AlertModal.vue';
import UploadAlertModal from '@/components/modals/UploadAlertModal.vue';
// import SelectLiveToVodModal from '@/components/modals/SelectLiveToVodModal.vue';
import _ from 'lodash';
import UppyUploader from '@/components/UppyUploader.vue';
import MetricsService from '@/services/MetricsService';
import { mapGetters } from 'vuex'

export default {
	name: 'VODUploadWidgetLight',
	components: {
		Dropzone,
		Spinner,
		AlertModal,
		UploadAlertModal,
		// SelectLiveToVodModal,
		UppyUploader,
	},
	props: {
		stream: {
		},
		mediaOnline: {
			type: Boolean,
		},
		schedulerSettings: {
			type: Object,
			default() { return {}; }
		},
		isOneMinuteBefore: {
			type: Boolean
		},
		streamAlive: {
			type: Boolean
		},
		canEncodeVideos: {
			type: Boolean,
			default: false
		},
		multipleUploads: {
			type: Boolean,
			default: true
		},
		maxFiles: {
			type: Number,
			default: 1
		},
		totalFilesPerStream: {
			type: Number,
			default: 999
		},
		// videoFiles: {
		// 	type: Array,
		// 	default: () => []
		// },
		mp4Only: {
			type: Boolean,
			default: true
		},
		isDisabledControl: {
			type: Boolean,
			default: false
		},
		isVodTrial: {
         type: Boolean,
         default() { return false }
		},
		vodSubExpiredDays: {
				type: Number,
				default() { return 1 }
		},
		advertisingMediaUpload: {
			type: Boolean,
			default: false
		},
		aioStorageLimit: {
			type: Object,
			default() { return {}; }
		},
	},
	data() {
		return {
			appUpdate: false,
			mediaInfoLib: null,
			widgetLoaded: false,
			processing: true,
			uploadErrorMessage: null,
			maxFileSizeErrorTitle: null,
			maxFileSizeErrorMessage: null,
			maxTotalFileSize: null,
			storageRestricitonsLoaded: false,
			scheduledSub: null,
			usedDvrStorage: {
				value: 0,
				loaded: false
			},
			maxFileNumberErrorMessage: null,
			uploadWidgetMaximized: false,
			uploadWidgetCollapse: true,
			uploadList: [],
			availableEncodingPresets: [
				{ id: '360p', text: '360p', minHeight: 300 },
				{ id: '480p', text: '480p', minHeight: 440 },
				{ id: '720p', text: '720p', minHeight: 700 },
				{ id: '1080p', text: '1080p', minHeight: 1020 }
			],
			filesDragging: false,
			allowMultipleUploads: this.multipleUploads,
			showUploadButton: true,
			cloudImp:false,
			showOptions:false,
		};
	},
	computed: {
		...mapGetters({
			loadingStatus: "Ui/loadingStatus",
			uploadFiles: "Ui/uploadFiles",
			videoFiles: "Streams/vodFiles",
			vodStreams: "Streams/vodStreams"
		}),
		activeTeam(){
			return this.$store.state.User.activatedTeam;
		},
		shouldCheckMediaQuality() {
			return this.$route.name === 'ScheduledStreamManageDashboard'
		},
		hasIncompatibleMediaFiles(){
			return this.uploadFiles.some(media => media?.mediaInfo && !this.isMediaCompatible(media.mediaInfo))
		},
		// pendingUploadsList() {
		// 	return this.uploadList.filter(u => !u.uploading);
		// },
		// activeUploadsList() {
		// 	return this.uploadList.filter(u => u.uploading === true);
		// },
		maxVideoFileSize() {
			let maxSize = null;
			const subscriptions =  _.cloneDeep(this.$store.state.User.subscriptions);

			if (this.stream && this.stream.type === 'vod' && this.aioStorageLimit) {
				this.aioStorageLimit.bytes += this.usedDvrStorage.value
				this.aioStorageLimit.unitsLeft -= this.usedDvrStorage.value
				// AIO plans does not have max file size setting, so we set it to 100GB by default
				maxSize = 100
				return maxSize
			}

			const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)
			
			activeScheduledSubs.forEach(sub => {
				try {
					if (sub.definitionOverride && sub.definitionOverride.schedulerMaxVideoSize) {
						sub.package.definition.schedulerMaxVideoSize = parseFloat(sub.definitionOverride.schedulerMaxVideoSize)
					}
					if (maxSize) {
						const tmpMaxSize = parseFloat(sub.package.definition.schedulerMaxVideoSize);
						if (tmpMaxSize > maxSize) {
							maxSize	= tmpMaxSize;
						}
					} else {
						maxSize	= parseFloat(sub.package.definition.schedulerMaxVideoSize);
					}
				} catch (error) {
					console.error(error);
				}
			})

			return maxSize
		},
		scheduledStorage() {
			let scheduledStorage = null;
			const subscriptions = this.$store.state.User.subscriptions;

			const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)
			
			activeScheduledSubs.forEach(sub => {
				try {
					let overrideStorage = parseFloat(sub.package.definition.storage);
					if (sub.definitionOverride && sub.definitionOverride.storage) {
						overrideStorage = parseFloat(sub.definitionOverride.storage)
					}
					if (scheduledStorage) {
						const tmpMaxSize = overrideStorage;
						if (tmpMaxSize > scheduledStorage) {
							scheduledStorage	= tmpMaxSize;
							this.scheduledSub = sub
						}
					} else {
						scheduledStorage = overrideStorage
						this.scheduledSub = sub
					}
				} catch (error) {
					console.error(error);
				}
			})

			return scheduledStorage
		},
		maxNumberOfVideoFiles() {
			return this.maxFiles;
		},
		vodStorageLimit() {
			while (!this.$store.state.User) {
				// Waiting for data
			}
			return parseFloat(this.$store.state.User.maxVodStorage);
		},
		isTrialSub() {
			let isTrialSub = false;
			let isPaidSub = false;
			const subscriptions = this.$store.state.User.subscriptions;

			
			subscriptions.forEach(sub => {
				try {
					if (['5cd5485126fd039846a3255f', '5ccd92f8152b7f25111c39cf', '5e8db3dcc3db0533322db725',
								'6362114709950a6a642540c4', '6362114709950a6a642540c2', '6362114709950a6a642540c3'].indexOf(sub.package._id) !== -1 && sub.enabled === true) {
						isTrialSub = true;
					} else if (sub.enabled === true) {
						isPaidSub = true;
					}
				} catch (error) {
					console.error(error);
				}
			})
			return isPaidSub ? false : isTrialSub;
		},
		scheduleSubscriptionsStatus() {
			const subscriptions = this.$store.state.User.subscriptions;
			const scheduledSubscriptions = _.filter(subscriptions, (sub) => sub.category === 'scheduled');
			const result = scheduledSubscriptions.find(element => element.enabled === true);
			if (result) {
				return true
			} else return false;
		},
	},
	
	async mounted() {
		this.setupMediaLibs();
		this.setupAWSLibs();
		await this.initMaxFileSizeData()
		await this.initVideoUpload()
		// setInterval(() => {
		// 	this.initMaxFileSizeData();
		// }, 5000);
	},
	destroyed() {
		// this.uploadList.forEach(this.cancelVideoUpload.bind(this));
	},
	directives: {
		'click-outside': {
			bind: function (el, binding, vnode) {
				el.clickOutsideEvent = function (event) {
					// console.log(event.target.classList[0].includes("uppy") );
				// here I check that click was outside the el and his children
				if (!(el == event.target || el.contains(event.target))) {
					// and if it did, call method provided in attribute value
					let uppywrapper = false;
					if(event.target.classList[0]){
						uppywrapper = event.target.classList[0].includes("uppy");
					}
					if((event.target.tagName == 'BUTTON' || event.target.tagName == 'SPAN')){
						var closest = event.target.tagName;
					}else{
						var closest = event.target.closest('.cloud-import-box-drop')
					}
					if(closest != null){
						uppywrapper = true;
					}
					if(!uppywrapper){vnode.context[binding.expression](event);}
					
				}
				};
				document.body.addEventListener('click', el.clickOutsideEvent)
			},
			unbind: function (el) {
				document.body.removeEventListener('click', el.clickOutsideEvent)
			},
		}
	},
	methods: {
		isMediaCompatible(mediaInfo) {
			if(!this.shouldCheckMediaQuality) return true

			if(mediaInfo.hasAudioTrack && !mediaInfo.isVbr) return true
			return false
		},
		getErrorMessage(mediaInfo){
			let message = ''
			
			if(mediaInfo.isVbr) {
				message = 'File should be CBR-encoded'
			}

			if(!mediaInfo.hasAudioTrack) {
				if(mediaInfo.isVbr) message += ' and have sound'
				else message = 'File should have sound'
			}

			message += '.'

			return message
		},
		toggleCI: function() {
			if(this.cloudImp == true){
    		this.cloudImp = false;
			}
			
    	},
		async initDvrStorageUsage() {
			let bytes = 0;
			this.usedDvrStorage.loaded = false;
			try {
				const resp = await MetricsService.getUserDvrStorage();
				bytes = resp.bytes || 0;
			} catch(e) {
				console.error('getUsedDvrStorage', e);
			}
			this.usedDvrStorage.loaded = true;
			this.usedDvrStorage.value = bytes;
		},
		onVideoAdded(videoItem) {
			this.$emit('video-added', videoItem);
			this.cloudImp = false;
			this.showOptions = false;
		},
		setupAWSLibs() {
			const vm = this
			let scriptId = 'aws-js'
			if (!document.getElementById(scriptId)) {
				// async load mediainfo js
				let scriptEl = document.createElement('script')
				scriptEl.src = 'https://sdk.amazonaws.com/js/aws-sdk-2.663.0.min.js'
				scriptEl.setAttribute('id', scriptId)
				scriptEl.onload = function() { initClass() }
				document.head.appendChild(scriptEl)
			} else {
				initClass()
			}

			function initClass() { vm.awsLoaded = true }
		},
		onFilesDrop(e) {
			e.preventDefault();
			e.stopPropagation();
			this.showOptions = false;
			if (e.dataTransfer.items) {
				for (const file of e.dataTransfer.items) {
					if (file.kind === 'file' && file.type.startsWith('video')) this.onMediaAdd(file.getAsFile());
				}
			} else {
				for (const file of e.dataTransfer.files) {
					if (file.type.startsWith('video')) this.onMediaAdd(file);
				}
			}
		},
		onMediaPresetSelect(media) {
			setTimeout(() => media.encodingUnitsRequired = computeEncodingUnits(media), 0);
		},
		isPresetSupported(media, preset) {
			return !media.mediaInfo ? false : media.mediaInfo.height >= preset.minHeight;
		},
		togglePresetList(media) {
			media.presetListCollapse = !media.presetListCollapse;
		},
		setupMediaLibs() {
			const vm = this;
			const scriptId = 'mediainfo-js';

			
				// async load mediainfo js
				const scriptEl = document.createElement('script');
				if ('WebAssembly' in window) {
					scriptEl.src = 'https://castr.com/libs/mediainfojs2/MediaInfoWasm.js';
				} else {
					scriptEl.src = 'https://castr.com/libs/mediainfojs2/MediaInfo.js';
				}

				scriptEl.setAttribute('id', scriptId);
				scriptEl.onload = function() {
					initClass();
				};
				document.head.appendChild(scriptEl);
			
			function initClass() {
				// eslint-disable-next-line no-undef
				vm.mediaInfoLib = MediaInfoLib({
					postRun() {
						if (typeof Promise !== 'undefined' && vm.mediaInfoLib instanceof Promise) {
							vm.mediaInfoLib.then((module)  => {
								vm.widgetLoaded = true;
								vm.mediaInfoLib = module
							});
						} else {
							vm.widgetLoaded = true;
						}
					}
				});
			}
		},
		async initMaxFileSizeData() {
			// Check max video file size (GB)
			let totalVodBytes = 0;
			const vodStorageTherehold = this.vodStorageLimit
			if (this.stream && this.stream.type === 'vod' && vodStorageTherehold) {
				await this.initDvrStorageUsage();
				const streams = this.vodStreams;
				
				streams.forEach((item) => {
					if (item.type === 'vod' && !item.liveParent) {
						totalVodBytes += item.totalBytes
					}
				})

				if (totalVodBytes > 0) {
					totalVodBytes = totalVodBytes / (1000 ** 3)
				}

				const dvrHumanSize = this.usedDvrStorage.value / 1000 ** 3;
				// console.log('totalVodBytes', totalVodBytes, 'vodStorageTherehold', vodStorageTherehold, 'dvrUsed', dvrHumanSize);
				this.maxTotalFileSize = (vodStorageTherehold - (totalVodBytes + dvrHumanSize)) * (1000 ** 3);
			}

			this.storageRestricitonsLoaded = true;
		},
		async initVideoUpload() {
			const el = this.$refs.uploadInput;
			if (!el) {
				setTimeout(() => this.initVideoUpload(), 5000);
				return;
			}

			const vm = this;
				if (!el.files.length) return;

				// Calculate max video files of the scheduled stream
				let maxFiles =  vm.maxNumberOfVideoFiles;
				maxFiles = vm.totalFilesPerStream - vm.videoFiles.length - vm.uploadList.length;
				if (el.files.length > maxFiles) {
					vm.maxFileNumberErrorMessage = `You can only upload a maximum of ${vm.totalFilesPerStream} files. Upgrade your plan if you need more files.`
					vm.$root.$emit('bv::show::modal', 'alert-video-max-file');
					el.value = null;
					return;
				};

				// Check max video file size (GB)
				let totalVodBytes = 0;								// total usage of all active(without deleted/archived) VOD + pseudoVOD(live to vod) 
				let totalRealVodBytes = 0							// total usage of all active(without deleted/archived) VOD

				const vodStorageTherehold = vm.vodStorageLimit
				if (vm.stream.type === 'vod' && vodStorageTherehold) {
					const streams = this.vodStreams;
					
					streams.forEach((item) => {
						if (item.type === 'vod') {
							totalVodBytes += item.totalBytes
						}

						if (item.type === 'vod' && !item.liveParent) {
							totalRealVodBytes += item.totalBytes
						}
					})

					if (totalVodBytes > 0) {
						totalVodBytes = totalVodBytes / (1000 ** 3)
					}

					if (totalRealVodBytes > 0) {
						totalRealVodBytes = totalRealVodBytes / (1000 ** 3)
					}

					let uploadQueueBytes = 0
					if(Array.isArray(el.files)) {
						el.files.forEach((item) => {
							uploadQueueBytes = uploadQueueBytes + (item.size / (1000 ** 3))
						})
					} else {
						
						Object.entries(el.files).forEach(
							([key, value]) => {
								// console.log(value.size),
								uploadQueueBytes = uploadQueueBytes + (value.size / (1000 ** 3))
							}
						);

						// el.files.forEach((item) => {
						// 	uploadQueueBytes = uploadQueueBytes + (item.size / (1000 ** 3))
						// })
					}
					

					const uploadQueue = vm.uploadList || []
					uploadQueue.forEach((item) => {
						uploadQueueBytes = uploadQueueBytes + (item.file.size / (1000 ** 3))
					})

					const dvrHumanSize = vm.usedDvrStorage.value / 1000 ** 3;
					if((totalRealVodBytes + uploadQueueBytes + dvrHumanSize) > vodStorageTherehold) {
						// console.log(`Storage capacity cannot exceed ${vodStorageTherehold}GB. Upgrade your plan to continue.`);
						vm.maxFileSizeErrorTitle = `Your storage limit has been exceeded`
						vm.maxFileSizeErrorMessage = `Your VOD storage limit (${vodStorageTherehold}GB) has been exceeded. Upgrade now to increase your video upload capacity.`
						vm.$root.$emit('bv::show::modal', 'alert-video-max-size');
						el.value = null;
						return;
					}
				}

				if (vm.stream.type === 'scheduled') {
					if (_.isNumber(vm.scheduledStorage)) {
						let fileSize = 0
						_.forEach(el.files, (file) => fileSize += (file.size / (1000 ** 3)));

						// Get storage usage
						const userId = vm.$store.state.User._id;
						const packageId = vm.scheduledSub.package._id
						const storageUsage = await MetricsService.getSubscriptionStorage(userId, packageId)
						const overStorage = (vm.scheduledStorage - (storageUsage?.bytes / (1000 ** 3)) - fileSize) < 0
						if (overStorage) {
							vm.maxFileSizeErrorMessage = `Storage capacity cannot exceed ${vm.scheduledStorage}GB. Upgrade your plan to continue.`
							vm.$root.$emit('bv::show::modal', 'alert-video-max-size');
							el.value = null;
							return;
						}
					}
					if (_.isNumber(vm.maxVideoFileSize)) {
						const overMaxSize = _.find(el.files,(file) => (file.size / (1000 ** 3)) > (vm.maxVideoFileSize - totalVodBytes));
						if (overMaxSize) {
							vm.maxFileSizeErrorMessage = `Your file size cannot exceed ${vm.maxVideoFileSize}GB. Upload smaller file or upgrade your plan to continue.`
							vm.$root.$emit('bv::show::modal', 'alert-video-max-size');
							el.value = null;
							return;
						}
					}
				}

				// #enabling non-mp4 uploads
				if (vm.mp4Only) {
					const ifHaveNonMp4 = _.find(el.files,(file) => file.type !== 'video/mp4');
					if(ifHaveNonMp4) {
						vm.$root.$emit('bv::show::modal', 'alert-video-encoding');
						el.value = null;
						return;
					}
				}
				this.$store.dispatch('Ui/addStreamToUpload', this.stream);
				Array.prototype.forEach.call(el.files, file => {
					// check for mime types
					const allowedExtensions = ["mp4"];
					const fileExtension = file.name.split(".").pop().toLowerCase();
					if (file.type.startsWith('video') && allowedExtensions.includes(fileExtension)) {
						vm.onMediaAdd(file,vm);
					} else {
						vm.$root.$emit("bv::show::modal", "forbidden-file-format-modal-light");
					}
				});

				el.value = null;
		},
		computeVideoPrecedence (video) {
			let precedence = 0;
			let siblingVids = _.cloneDeep(this.videoFiles)
			if (video) {
				siblingVids = _.filter(siblingVids, v => v.id !== video.id);
			}
			precedence = _.size(siblingVids) + 1;

			return precedence;
		},
		onMediaAdd(file,vm) {
			// not allow multiple uploads if disabled
			
			this.showOptions = false;
			if (this.allowMultipleUploads === false && this.uploadList.length > 0) {
				return;
			}

			let trimmedName = file.name;
			const nameChunks = trimmedName.split('.');
			const extname = nameChunks.length > 1 ? nameChunks.pop() : '';
			let basename = nameChunks.join('.');
			if (basename.length > 20) {
				basename = `${basename.substr(0, 14)} ... ${basename.substr(basename.length - 6)}`;
			}
			trimmedName = basename + '.' + extname;

			const newVideo = {
				id: `unnamed_${Math.random().toString().slice(2)}`,
				fileName: trimmedName,
				fileNameOriginal: file.name,
				bytes: file.size,
				mediaInfo: null,
				precedence: this.computeVideoPrecedence(),
				enabled: true,
				removing: false,
				statusProcessing: false,

				file,
				uploadable: true,
				uploading: false,
				uploadProgress: 0,
				encodingPresets: [],
				encodingUnitsRequired: 0,
				presetListCollapse: true,
				durationExceeded: false
			};

			// this.uploadList = [newVideo, ...this.uploadList];
			this.$store.dispatch('Ui/addFileToUpload', newVideo);
			// const uploadItem = this.uploadList[0];
			const uploadItem = this.uploadFiles[0]
			utils.inspectMediaFile(this.mediaInfoLib, file, info => {
				const durationSec = info.duration;
				const durationMins = Math.ceil(
					(durationSec < 60 ? 60 : durationSec) / 60
				);

				const mappedInfo = { ...info, durationMins };
				// uploadItem.mediaInfo = mappedInfo;
				const file = newVideo
				this.$store.dispatch('Ui/addFileData', {uploadItem: file, mappedInfo});
				if (this.isTrialSub && info.duration > 10 * 60) {
					// uploadItem.durationExceeded = true;
					this.$store.dispatch('Ui/addFileData', {uploadItem: file, durationExceeded: true})
				}
				this.$emit('upload-inspected', { upload: uploadItem, handler: 'raw' });
				// console.log('media-info', info)
			});

			if (this.multipleUploads === false) {
				this.showUploadButton = false;
			}

			this.$emit('upload-enqueue', { upload: newVideo, handler: 'raw' });
		},
		async requestSignedUploadUrl(uploadItem) {
			const fileObj = uploadItem.file;
			const uploadPayload = {
				encodingPresets: uploadItem.encodingPresets,
				metadata: {
					size: fileObj.size,
					type: fileObj.type,
					originalFilename: fileObj.name,
					precedence: uploadItem.precedence
				},
				mediaInfo: uploadItem.mediaInfo,
				streamType: this.stream.type,
				multipartSupport: fileObj.size / (1000 ** 3) > 1 // GB
			};

			const uploadUrl = await StreamService.requestVodMediaUploadUrl(this.stream.type === 'scheduled' ? this.stream._id : this.stream.key, uploadPayload);
			return uploadUrl;
		},
		startMultipartBucketUpload (uploadId, uploadItem, uploadCredentials, onBytesUploaded) {
      return new Promise((resolve) => {
        uploadItem.uploading = true

        let AWS = window.AWS
        AWS.config.update({
          region: uploadCredentials.region,
          useAccelerateEndpoint: uploadCredentials.useAccelerateEndpoint
        })

        // Initialize the Amazon Cognito credentials provider
        let identityConf = {
          IdentityPoolId: uploadCredentials.poolId,
          LoginId: UserService.getUser(this.activeTeam).email
        }

        AWS.config.credentials = new AWS.CognitoIdentityCredentials(identityConf)

        // Upload the File
        const uploadBucket = new AWS.S3({ params: { Bucket: uploadCredentials.bucketName } })
        const uploadOpts = {
          Key: uploadCredentials.keyPrefix + uploadId,
          ContentType: uploadItem.file.type,
          Body: uploadItem.file,
          queueSize: uploadCredentials.concurrency || 2, // default 2 parts in parallel
          partSize: uploadCredentials.chunkSize || (2 * 1000 * 1000), // default 2MB
          UseAccelerateEndpoint: true
				}

        const onBytes = (ev) => {
					let percent = (ev.loaded * 100) / ev.total
					onBytesUploaded(percent)
        }

        let multipartUploadHandle = uploadBucket.upload(uploadOpts)
        multipartUploadHandle.on('httpUploadProgress', onBytes)

        uploadItem.cancelSource = {
          cancel: () => void multipartUploadHandle.abort()
        }

        multipartUploadHandle.send((err, data) => {
          if (err) {
            uploadItem.uploadProgress = 0
            uploadItem.uploadError = true
            uploadItem.cancelSource = null
            uploadItem.uploading = false
          }

          resolve(!err)
        })
      })
    },
		async onVideoUploaded(uploadItem, uploadResult) {
			if (!uploadResult || !uploadResult.fileId) return;

			const oldId = uploadItem.id;

			uploadItem.id = uploadResult.fileId;
			uploadItem.mediaInfo = uploadResult.mediaInfo;
			uploadItem.creationTime = new Date();

			if (uploadResult.encodingRequired) {
				uploadItem.encodingRequired = true;
				uploadItem.encodingStatus = 'processing';
			}

			uploadItem.uploadable = false;
			uploadItem.file = null;

			const uindex = this.uploadList.indexOf(uploadItem);
			const newVideoArray = utils.removeArrayItem(this.uploadList, uindex);
			this.uploadList = newVideoArray;

			this.$emit('new-video', uploadItem);
			this.$emit('upload-dequeue', {upload: oldId, handler: 'raw'});
			if (!this.uploadList.length) {
				this.$emit('video-queue-emptied');
			}
			await this.$store.dispatch('Streams/getStreams');
			await this.$store.dispatch('Streams/getFilesInVODFolder')
			this.$notify({
				group: 'success',
				text: 'media uploaded successfully'
			});
			this.$emit('video-added', uploadItem);
			setTimeout(() => {
				this.$notify({ group: 'info', text: 'Video added to media list' });
			}, 2000);
			this.showOptions = false;
		},
		cancelVideoUpload(media) {
			if (!media) return;

			if (media.cancelSource) {
				media.cancelSource.cancel();
			}

			media.uploading = false;
		},
		async removeVideoFile(media) {
			media.removing = true;

			this.$emit('upload-dequeue', {upload: media, handler: 'raw'});

			this.cancelVideoUpload(media);

			const index = this.uploadList.indexOf(media);
			this.uploadList.splice(index, 1);

			if (!this.uploadList.length) {
				this.$emit('video-queue-emptied');
				this.showUploadButton = true;
			}
		},
		async clearUploadList() {
			const uploadList = this.uploadList.slice();
			uploadList.forEach(vid => void this.removeVideoFile(vid));
		},
		async selectLiveToVod() {
			setTimeout(() => {
				this.$root.$emit('bv::show::modal', 'modal-select-live-to-vod');
			}, 100);
		},
		onChange() {
			console.log('open light');
      // this.uploadList = [...this.$refs.uploadInput.files];
			this.initVideoUpload()
    },
    remove(i) {
      this.uploadList.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
			// console.log(event.currentTarget);
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drop-zone-hidden_dragover')) {
        event.currentTarget.classList.remove('drop-zone-hidden_dragleave');
        event.currentTarget.classList.add('drop-zone-hidden_dragover');
      }
			if (event.currentTarget.classList.contains('w-100')) {
        event.currentTarget.classList.add('z-10');
      }
    },
    dragleave(event) {
			// Clean up
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
			if (event.currentTarget.classList.contains('w-100')) {
        event.currentTarget.classList.remove('z-10');
      }
    },
    drop(event) {
      event.preventDefault();
      this.$refs.uploadInput.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('drop-zone-hidden_dragleave');
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
    },
		openFileUpload(event) {
			console.log('click');
			event.stopPropagation()
			event.preventDefault()
			console.log(this.$refs['uploadInput']);
			this.$refs['uploadInput'].click()
		}
	}
};

function computeEncodingUnits(media) {
	if (!media.mediaInfo) return;
	const encUnits = media.mediaInfo.durationMins * media.encodingPresets.length;
	return encUnits > 0 ? Math.ceil(encUnits) : encUnits;
}
</script>

<style scoped>
.vod_uploadbox {
	width: 100%;
}
.vod_uploadbox_line-fix {
	margin-top: -4rem;
}
.vod_uploadbox .video-item {
    background: var(--c-dark-2);
    border-radius: 6px;
    padding: 7px;
}
.font-weight-500 {
	font-weight: 500;
}
.drop-zone {
	border: 1px dashed var(--c-dark-4);
	border-radius: .5rem;
	padding: 1rem;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	aspect-ratio: 3 / 2;
	position: absolute;
}
.drop-zone-hidden .drop-zone {
	opacity: 0;
	transition: .3s;
}
.drop-zone-hidden_dragover .drop-zone {
	opacity: 1;
	transition: .3s;
}
.drop-zone-circle {
	width: 270px;
	height: 270px;
	background-color: var(--c-dark-2);
}
.video-item {
	position: absolute;
	left: 0;
	top: 6rem;
	width: 100%;
}
.progressbar-wrapper {
	height: 3px;
	border-radius: 3px;
	background-color: var(--c-dark-2);
}
.progress-label {
	position: absolute;
	top: 0;
	right: 1.75rem;
	color: var(--c-dark-6);
}
</style>

<style>
.vod_uploadbox + .video-list {
	opacity: 1;
	transition: .3s;
}
.vod_uploadbox:has(.drop-zone-hidden_dragover) + .video-list {
	opacity: 0;
	transition: .3s;
}
.no-shadow {
	box-shadow: none;
}
</style>